import React, { useCallback, useState } from "react";
import { CreateDomainStyles, NoSkillsText, OptionsGrid } from "./OptionsEditor.styled.js";
import { RangeToggle } from "../../../../../Components/Form/range-toggle/RangeToggle.jsx";
import { PlusCircle } from "@untitledui/icons/PlusCircle";
import { ActionButton, Modal } from "@talentbait/shared-components";
import { saveLanguage, updateProfileArrays } from "../../../Profile.utils.js";
import { useDebouncedCallback } from "../../../../../hooks/use-debounced-callback.hook.js";
import Actions from "../../../../../Actions.js";
import logger from "../../../../../utils/LoggerFrontend.js";
import { useTranslation } from "react-i18next";
import { simpleSelectStyles } from "../../../modals/Modals.styled.js";
import AddWeightedOptionForm from "../../../modals/AddWeightedOption.jsx";
import { withRouter } from "react-router-dom";
import withRefluxStore from "../../../../../Stores/withRefluxStore.jsx";
import ProfilesStore from "../../../Profile.store.js";

const WeightedOptions = ({
  index,
  req,
  filteredSkills,
  // Store
  profile
}) => {
  const { t } = useTranslation();
  const { category, options } = req;

  const [isWeightedModalOpen, setIsWeightedModalOpen] = useState(false);

  const handleAddOption = useCallback(() => setIsWeightedModalOpen(true), []);
  const closeWeightedModal = useCallback(() => setIsWeightedModalOpen(false), []);

  const handleNewOption = (option) => {
    const newOptions = [...options, option];
    const updatedRequirement = { ...req, options: newOptions };

    const update = updateProfileArrays({
      profile,
      index,
      updatedRequirement,
      filteredSkills
    });

    logger.log("ModifyOptions:handleNewOption", "add new option", {
      profileId: profile.id,
      update,
      newOptions
    });

    Actions.patchProfile(profile.id, update);
    closeWeightedModal();
  };

  const handleWeightChange = (optionName, newWeight, category) => {
    const updatedOptions = options.map((option) =>
      option.name === optionName
        ? { name: option.name, weight: saveLanguage(newWeight, category) }
        : option
    );

    const updatedRequirement = { ...req, options: updatedOptions };

    const update = updateProfileArrays({
      profile,
      index,
      updatedRequirement,
      filteredSkills
    });

    logger.log("ModifyOptions:handleWeightChange", "update weight change in range toggle", {
      profileId: profile.id,
      update,
      updatedOptions
    });
    Actions.patchProfile(profile.id, update);
  };

  const [debouncedWeightChange] = useDebouncedCallback(handleWeightChange, 500);

  const isEmpty = req.options.length === 0;

  return (
    <>
      {isEmpty ? (
        <NoSkillsText>{t("Add a weighted option for this category")}</NoSkillsText>
      ) : (
        <OptionsGrid>
          {options.map((option) => {
            // Ensure weight is a valid number, default to 0 if not
            const safeWeight =
              typeof option.weight === "number" && !isNaN(option.weight) ? option.weight : 0;

            return (
              <div key={option.name} style={{ position: "relative" }}>
                <RangeToggle
                  name={option.name}
                  weight={safeWeight}
                  onWeightChange={debouncedWeightChange}
                  category={category}
                  width="fit-content"
                />
              </div>
            );
          })}
        </OptionsGrid>
      )}

      <ActionButton
        icon={<PlusCircle size="20px" />}
        variant="link"
        text={t("Add option")}
        onClick={handleAddOption}
        styles={CreateDomainStyles}
      />

      <Modal
        isOpen={isWeightedModalOpen}
        setIsOpen={closeWeightedModal}
        styles={simpleSelectStyles}
      >
        <AddWeightedOptionForm
          req={req}
          selectedIndex={index}
          filteredSkills={filteredSkills}
          onSubmit={handleNewOption}
          onCancel={closeWeightedModal}
        />
      </Modal>
    </>
  );
};

export default withRouter(withRefluxStore(WeightedOptions, [ProfilesStore], ["profile"]));
